var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rateEchart"},[_c('div',{staticClass:"echarts-title"},[_vm._v("客户评分：80（No.3）")]),_c('div',{ref:"RateEchart",staticClass:"echarts-rate"})])}
var staticRenderFns = []

export { render, staticRenderFns }